import React from "react";
import { Box, Typography } from "@mui/material";

interface IProps {
  error: string;
  warning?: string;
}

const InputMessage = ({ error, warning }: IProps): React.ReactElement => (
  <Box position="relative">
    <Box mt="1px" display="flex" alignItems="center">
      <Typography
        fontSize="12px"
        lineHeight="1"
        m={0}
        sx={{
          ...(!!error && { color: "secondary.main" }),
          ...(!!warning && { color: "warning.main" }),
        }}
      >
        {error || warning}
      </Typography>
    </Box>
  </Box>
);

export default InputMessage;
